import { IParseable } from '../../shared/models/IParseable';

export class SearchResult<T extends IParseable> {
    pageNumber: number;
    pageSize: number;
    pageCount: number;
    result: T[] = [];

    public static parse<T extends IParseable>(json, typeInstance: T): SearchResult<T> {
        let searchResult = new SearchResult<T>();
        Object.assign(searchResult, json);
        let parsedInstances: T[] = [];
        searchResult.result.forEach(r => {
            parsedInstances.push(typeInstance.parse(r) as T);
        });
        searchResult.result = parsedInstances;
        return searchResult;
    }
}